import styled, { css } from 'styled-components';

import { Box as BaseBox } from '@/components/Box';
import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { FormProvider as BaseFormProvider } from '@/components/FormProvider';
import { Row as BasicRow } from '@/components/Row';

export const FormWrap = styled(BaseBox)<{ $background?: string }>`
  ${({ $background }) => css`
    background: ${$background ?? '#fff'};
  `}
  max-width: 500px;
`;

export const Box = styled(BaseBox)`
  display: block;
  overflow: hidden;
  width: 100vw;
  height: 30vh;
  position: relative;

  ${({ theme }) => css`
    ${theme.media.sm.up} {
      min-height: 300px;
    }

    ${theme.media.md.up} {
      min-height: 300px;
    }
  `}
`;

export const Row = styled(BasicRow)<{ $widthLimit?: boolean }>`
  margin: 1rem;

  ${({ $widthLimit = true, theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: ${$widthLimit ? '388px' : ''};
    }
  `}
`;

export const ArchivesFormGroup = styled(Flex)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  ${({ theme }) => css`
    ${theme.media.md.up} {
      max-width: 404px;
    }
  `}
`;

export const ArchivesFormRow = styled(BasicRow)`
  margin: 1rem 0;

  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 400px;
    }
  `}
`;

export const FormProvider = styled(BaseFormProvider)`
  && {
    ${({ theme }) => css`
      ${theme.components.newsLetter.formFontSize &&
      css`
        label,
        input,
        div[class$='control'],
        div[class$='menu'] {
          font-size: ${theme.components.newsLetter.formFontSize};
        }
      `}
    `};
  }
`;

export const CheckBoxWrapper = styled(Col)`
  ${({ theme }) => css`
    p {
      ${theme.components.newsLetter.footerFontSize &&
      css`
        font-size: ${theme.components.newsLetter.footerFontSize};
      `}
      ${theme.components.newsLetter.footerLineHeight &&
      css`
        line-height: ${theme.components.newsLetter.footerLineHeight};
      `}
    }
  `};
`;
